import React, { useState } from "react";
import { Row, Col, FormGroup, Input, Label } from "reactstrap";
import Select from "react-select";
import { getAPI, masterServiceBaseUrl, failureToast } from "services/http";

const HeaderInformation = (props) => {
  const {
    activeGroupCode,
    activeCompanyCode,
    submitDataHandler,
    houseBankDetails,
    getDisplayValue,
    actionDisabled,
  } = props;
  const [showCompanyCode, setShowCompanyCode] = useState([]);

  const getCompanyCode = (value) => {
    try {
      getAPI(
        masterServiceBaseUrl + `/companyCode/getCompanyCodeByGroup/${value}`,
        (data) => {
          let tempCompanyCode = [];
          data &&
            data.data.map((item) => {
              tempCompanyCode.push({
                value: item.id,
                label: item.companyCodeDispValue,
              });
            });
          setShowCompanyCode(tempCompanyCode);
        },
        (data) => {
          setShowCompanyCode([]);
          failureToast(data["message"]);
        }
      );
      submitDataHandler("", "companyCodeId");
    } catch (e) {
      console.log("Error ", e);
    }
  };

  return (
    <Row>
      <Col>
        <Row>
          <Col md={6}>
            <FormGroup>
              <Label className="form-control-label">
                <span className="custom-span-color">*</span>Group Code
              </Label>
              <Select
                isDisabled={actionDisabled}
                value={{
                  value: houseBankDetails["groupCodeId"],
                  label: houseBankDetails["groupCodeId"] ? (
                    getDisplayValue(
                      houseBankDetails["groupCodeId"],
                      "GroupCodeID"
                    )
                  ) : (
                    <span className="customSpan">Select Group Code</span>
                  ),
                }}
                options={activeGroupCode}
                onChange={(e) => {
                  getCompanyCode(e.value);
                  submitDataHandler(e.value, "groupCodeId");
                }}
              ></Select>
            </FormGroup>
          </Col>
          <Col md={6}>
            <FormGroup>
              <Label className="form-control-label">
                <span className="custom-span-color">*</span>Company Code
              </Label>
              <Select
                isDisabled={actionDisabled}
                value={{
                  value: houseBankDetails["companyCodeId"],
                  label: houseBankDetails["companyCodeId"] ? (
                    getDisplayValue(
                      houseBankDetails["companyCodeId"],
                      "CompanyCodeID"
                    )
                  ) : (
                    <span className="customSpan">Select Company Code</span>
                  ),
                }}
                options={showCompanyCode}
                onChange={(e) => submitDataHandler(e.value, "companyCodeId")}
              ></Select>
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col md={6}>
            <FormGroup>
              <Label className="form-control-label">
                <span className="custom-span-color">*</span>Bank Account ID
              </Label>
              <Input
                data-testid="bankAccountId"
                className="customInput"
                disabled={actionDisabled}
                maxLength={50}
                value={houseBankDetails["bankAccountId"]}
                placeholder="Enter Bank Account ID"
                onChange={(e) =>
                  submitDataHandler(e.target.value, "bankAccountId")
                }
              />
            </FormGroup>
          </Col>
          <Col md={6}>
            <FormGroup>
              <Label className="form-control-label">
                <span className="custom-span-color">*</span>Bank Short Key
              </Label>
              <Input
                data-testid="bankShortey"
                className="customInput"
                maxLength={50}
                disabled={actionDisabled}
                value={houseBankDetails["bankShortKey"]}
                placeholder="Enter Bank Short Key"
                onChange={(e) =>
                  submitDataHandler(e.target.value, "bankShortKey")
                }
              />
            </FormGroup>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default HeaderInformation;
